import React from 'react';
import { motion } from 'framer-motion';
import { CalendarCheck, CheckCircle2, Truck } from 'lucide-react';
import { Button } from '../ui/Button';
interface HeroProps {
  onReserve: () => void;
}
const HIGHLIGHTS = ['1–3 day or 7-day rentals', 'Same/next-day delivery', 'Pay online or hold with a card'];
export function Hero({
  onReserve
}: HeroProps) {
  return <section id="top" className="w-full bg-background" data-id="element-241">
      <div className="container grid gap-10 py-16 md:grid-cols-2 md:items-center md:py-24" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-243">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-secondary px-3 py-1 text-xs font-medium text-secondary-foreground" data-id="element-244">
            <Truck className="h-3.5 w-3.5 text-primary" data-id="element-245" />
            Serving the greater metro area
          </span>
          <h1 className="mt-5 text-4xl font-semibold tracking-tight text-foreground sm:text-5xl" data-id="element-246">
            Dumpster rentals made simple, fast, and fair.
          </h1>
          <p className="mt-4 max-w-lg text-lg text-muted-foreground" data-id="element-247">
            Reserve the right size online in minutes. We deliver, you fill it,
            we haul it away — with straightforward pricing and no surprise fees.
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row" data-id="element-248">
            <Button size="lg" onClick={onReserve} className="gap-2" data-id="element-249">
              <CalendarCheck className="h-4 w-4" data-id="element-250" />
              Reserve a dumpster
            </Button>
            <Button size="lg" variant="outline" onClick={() => {
            document.getElementById('sizes')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-251">
              View sizes & pricing
            </Button>
          </div>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2" data-id="element-252">
            {HIGHLIGHTS.map(item => <li key={item} className="flex items-center gap-2 text-sm text-foreground" data-id="element-253">
                <CheckCircle2 className="h-4 w-4 text-primary" data-id="element-254" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: 'easeOut'
      }} className="relative" data-id="element-255">
          <div className="overflow-hidden rounded-2xl border border-border shadow-sm" data-id="element-256">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/8ca52b08-2f6a-43e9-9b61-750ccb514667.jpg" alt="Green roll-off dumpster being delivered to a residential driveway" className="h-[360px] w-full object-cover sm:h-[440px]" data-id="element-257" />
          </div>
          <div className="absolute -bottom-5 left-5 flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 shadow-md" data-id="element-258">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-259">
              <Truck className="h-5 w-5" data-id="element-260" />
            </span>
            <div className="leading-tight" data-id="element-261">
              <p className="text-sm font-semibold text-card-foreground" data-id="element-262">
                Next-day delivery
              </p>
              <p className="text-xs text-muted-foreground" data-id="element-263">
                Available in most areas
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}